export const masks = {
  cpf: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
  rg: [/\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/],
  cep: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
  cnpj: [
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '/',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
  ],
  phone: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  cns: [
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
}

export function unmaskNumbers(input: string) {
  if (typeof input !== 'string') {
    throw new Error('Input to mask must be string')
  }

  return input.replace(/[^0-9]/gi, '')
}

export function maskNumbers(input: string, mask: Array<string | RegExp>) {
  if (typeof input !== 'string') {
    throw new Error('Input to mask must be string')
  }

  const cleanInput = unmaskNumbers(input)

  let result = ''
  for (let index = 0, position = 0; index < mask.length; index++) {
    if (mask[index] instanceof RegExp) {
      if (!cleanInput[position]) {
        return result
      }

      result += cleanInput[position]
      position++
    } else {
      result += mask[index]
    }
  }

  return result
}

function onlyNumbers(s: string) {
  return s.replace(/\D+/g, '')
}

function phoneMaskWithDdd(s: string) {
  return onlyNumbers(s)
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(\d{4})-(\d)(\d{3})(\d)\d*/, '$1$2-$3$4')
}

function CPFMask(s: string) {
  if (s.length > 14) {
    s = s.slice(0, 14)
  }
  return onlyNumbers(s)
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3}\.\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3}\.\d{3}\.\d{3})(\d)/, '$1-$2')
}

function CNSMask(s: string) {
  s = onlyNumbers(s)
  if (s.length > 15) {
    s = s.slice(0, 15)
  }

  return s
    .replace(/(\d{3})(\d)/, '$1 $2')
    .replace(/(\d{3}) (\d{4})(\d)/, '$1 $2 $3')
    .replace(/(\d{3}) (\d{4}) (\d{4})(\d)/, '$1 $2 $3 $4')
}

function dateMask(s: string) {
  const match = s.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (match) {
    s = `${match[3]}/${match[2]}/${match[1]}`
  } else {
    s = s.replace(/[^0-9/]/g, '')
  }
  return s.replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3')
}

function CEPMask(s: string) {
  s = onlyNumbers(s)

  s = s.replace(/^(\d{5})(\d{3}).*/, '$1-$2')

  return s
}

function CNPJMask(s: string) {
  s = onlyNumbers(s)

  s = s.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5')

  return s
}

function RegistrationStatusMask(value: string) {
  if (value === 'active') return 'Ativa'
  if (value === 'inapt') return 'Inapta'
  if (value === 'extinct') return 'Extinta'
}

function companySizeMask(value: string) {
  const normalizedValue = value.trim().toLowerCase()

  if (normalizedValue === 'mei') return 'MEI'
  if (normalizedValue === 'me' || normalizedValue === 'micro') return 'ME'
  if (normalizedValue === 'epp' || normalizedValue === 'small') return 'EPP'
  if (normalizedValue === 'other') return 'Outro porte'
  if (normalizedValue === 'unknown') return 'Porte desconhecido'

  return value
}

function ageGroupMask(value: string) {
  const ageGroup = {
    startup: 'Startup',
    young: 'Jovem',
    growth: 'Crescimento',
    established: 'Estabelecida',
  }

  return ageGroup[value as keyof typeof ageGroup] ?? 'Desconhecido'
}

export const applyMask = (value: string | boolean, mask: string | undefined, type?: string) => {
  if (typeof value === 'boolean' || type === 'boolean') {
    return value ? 'Sim' : 'Não'
  }

  switch (mask) {
    case 'phone':
      return phoneMaskWithDdd(value)
    case 'date':
      return dateMask(value)
    case 'cep':
      return CEPMask(value)
    case 'sex':
      return value === 'male' ? 'Masculino' : 'Feminino'
    case 'cpf':
      return CPFMask(value)
    case 'cns':
      return CNSMask(value)
    case 'cnpj':
      return CNPJMask(value)
    case 'currency':
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
        Number(value),
      )
    case 'registrationStatus':
      return RegistrationStatusMask(value)
    case 'companySize':
      return companySizeMask(value)
    case 'ageGroup':
      return ageGroupMask(value)
    default:
      return value
  }
}
